import React from "react";
import { Input } from "reactstrap";

const ToggleCustomField = ({
  message,
  inputValue,
  onChange,
  className,
  disabled = false,
}) => {
  return (
    <div className={className}>
      <h5>{message}</h5>
      <Input
        value={inputValue}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
      />
    </div>
  );
};

export default ToggleCustomField;
